import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4 simple-patterns" }

import { type MonthType, MONTHS } from './date_time_range_generators';

export default /*@__PURE__*/_defineComponent({
  __name: 'SeasonPicker',
  props: /*@__PURE__*/_mergeModels({
    seasons: { type: Boolean }
  }, {
    "modelValue": {
  type: Array as () => MonthType[]
},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const selectedMonths = _useModel<MonthType[]>(__props, "modelValue");


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.seasons)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          size: "x-small",
          variant: "outlined",
          class: "mr-2 mb-2",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedMonths.value = ['December', 'January', 'February']))
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode("Winter", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.seasons)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 1,
          size: "x-small",
          variant: "outlined",
          class: "mr-2 mb-2",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (selectedMonths.value = ['March', 'April', 'May']))
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode("Spring", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.seasons)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 2,
          size: "x-small",
          variant: "outlined",
          class: "mr-2 mb-2",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (selectedMonths.value = ['June', 'July', 'August']))
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode("Summer", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.seasons)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 3,
          size: "x-small",
          variant: "outlined",
          class: "mr-2 mb-2",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (selectedMonths.value = ['September', 'October', 'November']))
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createTextVNode("Fall", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_btn, {
      size: "x-small",
      variant: "outlined",
      class: "mr-2 mb-2",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (selectedMonths.value = _unref(MONTHS).slice()))
    }, {
      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
        _createTextVNode("All Months", -1)
      ]))]),
      _: 1
    }),
    _createVNode(_component_v_btn, {
      size: "x-small",
      variant: "outlined",
      class: "mr-2 mb-2",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (selectedMonths.value = []))
    }, {
      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
        _createTextVNode("Clear Months", -1)
      ]))]),
      _: 1
    })
  ]))
}
}

})